export class CargoDialogResult {
	previewURL: string | undefined;
}
